import { render } from "./CreateCharter.vue?vue&type=template&id=2f97d7a0&scoped=true"
import script from "./CreateCharter.vue?vue&type=script&lang=js"
export * from "./CreateCharter.vue?vue&type=script&lang=js"

import "./CreateCharter.vue?vue&type=style&index=0&id=2f97d7a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f97d7a0"]])

export default __exports__